import {_} from "vue-underscore";
import api from "../utils/api.js";
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { createStripe } from "../../utilities/stripe.js";

var bugsnagClient = null;

const credentials_uri = api.credentialsUri();

export const config = {
    namespaced: true,
    state: {
        bugsnagToken: null,
        pubsubJson: {},
        stripeToken: null
    },
    getters: {
        getBugsnagToken(state) {
            return state.bugsnagToken;
        },
        getPubSubJson(state) {
            return state.pubsubJson;
        },
        getStripeToken(state) {
            return state.stripeToken;
        }
    },
    mutations: {
        setBugsnagToken(state, payload) {
            state.bugsnagToken = payload.credentials.bugsnag;
            
            if(!bugsnagClient) {
                bugsnagClient = Bugsnag.start({
                    apiKey: state.bugsnagToken,
                    plugins: [new BugsnagPluginVue()],
                    appVersion: BUNDLE_VERSION,
                    releaseStage: RELEASE_STAGE,
                });
                Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)
            }
        },
        setPubSubJson(state, payload) {
            if(payload.credentials.pubsub) {
                state.pubsubJson = payload.credentials.pubsub;
            }
        },
        setStripeToken(state, payload) {
            state.stripeToken = payload.credentials.stripe;
            createStripe(state.stripeToken);
        }
    },
    actions: {
        fetchCredentials(context) {
            return api
                .get(credentials_uri)
                .then(response => {
                    context.commit("setBugsnagToken", response);
                    context.commit("setPubSubJson", response);
                    context.commit("setStripeToken", response);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
